<template lang="en">
<div class="doctor-profile">
    <Navigation></Navigation>
    <div id="breadcrumb">
        <div class="container">
            <ul>
                <li><router-link tag="a" to="/">Inicio</router-link></li>
                <li>Contacto</li>
            </ul>
        </div>
    </div>
    <!-- /breadcrumb -->

    <div class="container margin_60_35">
        <div class="row">
            <aside class="col-lg-3 col-md-4">
                <div id="contact_info">
                    <h3>Información de contacto</h3>
                    <!-- <p>
                        11 Fifth Ave - New York, US<br> + 61 (2) 8093 3400<br>
                        <a href="#">info@domain.com</a>
                    </p> -->
                    <ul>
                        <li><strong>Consultas generales</strong>
                            <a href="mailto:hello@doctorconsultas.com">hello@doctorconsultas.com</a><br>
                        </li>
                        <li><strong>Administración</strong>
                            <a href="mailto:administracion@doctorconsultas.com">administracion@doctorconsultas.com</a><br>
                        </li>
                    </ul>
                </div>
            </aside>
            <!--/aside -->
            <div class=" col-lg-8 col-md-8 ml-auto">
                <div class="box_general">
                    <h3>Contactanos</h3>
                    <p>
                        Envianos tu consulta
                    </p>
                    <div>
                        <div id="message-contact"></div>
                        <form @submit.prevent="contact"  v-if="!sended">
                            <div class="row">
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="text" 
                                            class="form-control" 
                                            placeholder="Nombre" 
                                            v-model="form.name" 
                                            :class="{'is-invalid':validationErrors['data.name']}"
                                            >
										<div class="invalid-feedback">{{validationErrors['data.name']}}</div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="text" 
                                            class="form-control" 
                                            placeholder="Apellido" 
                                            v-model="form.lastname" 
                                            :class="{'is-invalid':validationErrors['data.lastname']}"
                                            >
										<div class="invalid-feedback">{{validationErrors['data.lastname']}}</div>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="text" 
                                            class="form-control" 
                                            placeholder="Email" 
                                            v-model="form.email" 
                                            :class="{'is-invalid':validationErrors['data.email']}"
                                            >
										<div class="invalid-feedback">{{validationErrors['data.email']}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <textarea rows="5" 
                                            class="form-control" 
                                            style="height:100px;"
                                            placeholder="Ingrese su mensaje"
                                            v-model="form.message" 
                                            :class="{'is-invalid':validationErrors['data.message']}"
                                            >
                                        </textarea>
                                        <div class="invalid-feedback">{{validationErrors['data.message']}}</div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input type="text" id="verify_contact" class=" form-control" placeholder=" 3 + 1 =">
                                    </div>
                                </div>
                            </div> -->
                            <input type="submit" class="btn_1" value="Enviar mensaje" v-if="!loading" >
                            <div class="btn_1" v-else>
                                Enviando...
                            </div>
                        </form>
                        <div v-else class="alert alert-success text-center">
                            <h5>Mensaje enviado correctamente</h5>
                            <br>
                            En instantes nos podremos en contacto contigo!!<br><br>Muchas gracias por contactarnos.
                        </div>
                    </div>
                    <!-- /col -->
                </div>
            </div>
            <!-- /col -->
        </div>
        <!-- End row -->
    </div>
    

    <Footer></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'

import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

export default {
    name: 'About',
    metaInfo: {
		title: 'Contacto',
	},
    components: {
        Navigation,
        Footer,
    },
    data() {
        return {
            form:{
				name: '',
				lastname:'',
				email:'',
				message:'',
			},
			validationErrors:{},
            loading:false,
            sended:false,
        }
    },
    methods:{
        contact(){

            if(!this.loading){
				this.validationErrors = {};

                if(this.validate()){
                    
                    this.loading=true;
                    
                    var dataInput = {	
                        name: this.form.name,			
                        lastname: this.form.lastname,			
                        email: this.form.email,			
                        message: this.form.message,			
                    };

                    this.$apollo.mutate({
                        mutation: gql`mutation ( $data:ContactMessageInput! ){
                            createContactMessage( data: $data) {
                                id
                            }
                        }`,
                        variables: {
                            data: dataInput,
                        }
                    })
                    .then(() => {
                        this.loading=false;
                        this.form ={
                            name: '',
                            lastname:'',
                            email:'',
                            message:''
                        };
                        this.sended = true;
                    })
                    .catch(error => {
                        let { graphQLErrors } = error;
                        if (graphQLErrors[0].extensions.category === "validation") {
                            this.validationErrors = this.parseErrors(graphQLErrors[0].extensions.validation);
                        }else{
                            this.validationErrors['general'] = 'Se ha producido un error';
                        }
                        this.loading=false;
                    })
                }
			}

        },
        validate(){
            let error = false;
            this.validationErrors = {};
            
            if( !this.form.name || this.form.name.length <=2 || this.form.name.length > 20 ){
                error=true;
                this.validationErrors['data.name'] = 'Ingrese su nombre';
            }
            if( !this.form.lastname || this.form.lastname.length <=2 || this.form.lastname.length > 20 ){
                error=true;
                this.validationErrors['data.lastname'] = 'Ingrese su apellido';
            }
            if( !this.form.email || !this.validateEmail(this.form.email) ){
                error=true;
                this.validationErrors['data.email'] = 'Ingrese un email válido';
			}
			
			if( !this.form.message || this.form.message.length<3  ){
                error=true;
                this.validationErrors['data.message'] = 'Ingrese su mensaje';
            }
            
            if( !error ){
                return true;
            }
            return false;
        },
        parseErrors(errors){
            let parsedErrors = [];
            Object.keys(errors).forEach( (key) => {
                parsedErrors[key] = errors[key][0];
                
            });
            return parsedErrors;
		},
		validateEmail(email) {
			var re = /\S+@\S+\.\S+/;
			return re.test(String(email).toLowerCase());
		},
    }

}
</script>

<style scoped>
/*-------- 2.7 Contact page --------*/
#contact_info {
  margin: 35px 0 0 0;
}
@media (max-width: 767px) {
  #contact_info {
    /* For less than 767px */
    margin: 0 0 35px 0;
  }
}
#contact_info h3 {
  font-size: 18px;
  font-size: 1.125rem;
}
#contact_info h4 {
  font-size: 14px;
  font-size: 0.875rem;
}
#contact_info ul li {
  margin-bottom: 15px;
}
#contact_info ul li strong {
  display: block;
  font-weight: 500;
}

#map_contact {
  width: 100%;
  height: 500px;
}
@media (max-width: 767px) {
  #map_contact {
    /* For less than 767px */
    height: 350px;
  }
}

.error_message {
  font-weight: 500;
  color: #f26c4f;
  display: inline-block;
  margin-bottom: 10px;
}
</style>
